// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__mR7IS","wrapper":"Brand_wrapper__tP0Tk","title":"Brand_title__AxZ9H","list":"Brand_list__f5Z67"};